import { isDesktop } from "@enfusion-ui/web-core";
async function asyncNoop() { }
export function getRemote() {
    try {
        if (isDesktop())
            return fin.Window.getCurrentSync();
        return {
            close: asyncNoop,
            minimize: asyncNoop,
            restore: asyncNoop,
            maximize: asyncNoop,
            getState: async () => "normal",
            addListener: asyncNoop,
            removeListener: asyncNoop,
        };
    }
    catch (err) {
        return {
            close: asyncNoop,
            minimize: asyncNoop,
            restore: asyncNoop,
            maximize: asyncNoop,
            getState: async () => "normal",
            addListener: asyncNoop,
            removeListener: asyncNoop,
        };
    }
}
export async function closeWindow() {
    await getRemote().close();
}
export async function minimizeWindow() {
    await getRemote().minimize();
}
export async function maximizeWindow() {
    const WIN = getRemote();
    if ((await WIN.getState()) === "maximized") {
        await WIN.restore();
    }
    else {
        await WIN.maximize();
    }
}
